export default __webpack_public_path__ + "static/media/criticalform.6f0a5dad.svg";